import Nav from "../Nav";
import logo from "../../assets/logo.svg";
import "./Header.css";
import menuIcon from "../../assets/menu_icon.svg";
import { useEffect, useState } from "react";
import MobileNav from "./Mobile";
import { useLocation } from "react-router-dom";

export default function Header() {
  // Declare the states
  const [isNavOpen, setIsNavOpen] = useState(false);
  const toggleNav = () => setIsNavOpen(!isNavOpen);
  const location = useLocation();

  // This will close the mobile nav after navigating (mobile / tablet only)
  useEffect(() => {
    setIsNavOpen(false);
  }, [location]);

  return (
    <header className="container navbar">
      {/* Logo */}
      <div className="navbar-logo" style={{ maxWidth: "15.625rem" }}>
        <img src={logo} alt="Logo" />
      </div>

      {/* Menu button (for mobile) */}
      <button
        className="navbar-mobile"
        onClick={toggleNav}
        aria-expanded={isNavOpen}
        aria-label="Toggle navigation menu"
      >
        <img src={menuIcon} alt="Navigation Menu" />
      </button>

      {/* Navigation links (for desktop) */}
      <Nav className="navbar-links" />
      {/* Mobile navigation (for mobile) */}
      <MobileNav isOpen={isNavOpen} />
    </header>
  );
}
